import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { heroSlides } from '@/mocks/home';

export default function HeroCarousel() {
  const [active, setActive] = useState(0);
  const [paused, setPaused] = useState(false);

  useEffect(() => {
    if (paused) return undefined;
    const timer = window.setInterval(() => {
      setActive((prev) => (prev + 1) % heroSlides.length);
    }, 7000);
    return () => window.clearInterval(timer);
  }, [paused]);

  const slide = heroSlides[active];

  return (
    <section
      className="relative w-full overflow-hidden bg-primary-950"
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
    >
      <div className="relative w-full h-[520px] md:h-[600px]">
        {heroSlides.map((item, index) => (
          <div
            key={item.id}
            className={`absolute inset-0 transition-opacity duration-[1200ms] ${
              index === active ? 'opacity-100' : 'opacity-0'
            }`}
          >
            <img
              src={item.cover}
              alt={item.title}
              title={`${item.title} - 琉璃神社`}
              className="w-full h-full object-cover object-top"
            />
          </div>
        ))}

        <div className="absolute inset-0 bg-gradient-to-r from-primary-950/90 via-primary-950/60 to-primary-950/15"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-primary-950/70 via-transparent to-primary-950/25"></div>

        <div className="relative h-full w-full px-4 md:px-10 lg:px-14 flex items-end md:items-center pb-24 md:pb-0">
          <div className="w-full max-w-[760px]">
            <div key={slide.id} className="animate-fade-up">
              <div className="flex flex-wrap items-center gap-3">
                <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded bg-accent-500 text-primary-950 text-[11px] tracking-wide">
                  <i className="ri-flashlight-fill w-3 h-3 flex items-center justify-center"></i>
                  {slide.tag}
                </span>
                <span className="text-[11px] tracking-[0.22em] uppercase text-background-100/70 font-label">
                  Ruri Shrine Feature
                </span>
              </div>

              <h1 className="mt-5 text-2xl md:text-[44px] md:leading-[1.28] font-semibold text-background-50 tracking-wide">
                {slide.title}
              </h1>
              <p className="mt-4 text-sm md:text-base leading-7 md:leading-8 text-background-100/80 max-w-xl line-clamp-3 md:line-clamp-none">
                {slide.summary}
              </p>
              <p className="mt-4 text-[11px] md:text-xs text-background-100/60 font-label tracking-wide">
                {slide.meta}
              </p>

              <div className="mt-7 flex flex-wrap items-center gap-3">
                <Link
                  to={slide.to}
                  className="inline-flex items-center gap-2 h-11 px-6 rounded-md bg-background-50 text-primary-900 text-sm hover:bg-accent-500 hover:text-primary-950 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {slide.label}
                  <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
                </Link>
                <Link
                  to="/category/news"
                  className="inline-flex items-center gap-2 h-11 px-6 rounded-md border border-background-50/30 text-background-50 text-sm hover:border-background-50/70 transition-colors whitespace-nowrap cursor-pointer"
                >
                  浏览全部资讯
                </Link>
              </div>
            </div>
          </div>
        </div>

        <div className="absolute bottom-6 md:bottom-10 right-4 md:right-10 lg:right-14 flex items-center gap-4 z-10">
          <span className="hidden sm:block text-[11px] text-background-100/60 font-label tracking-[0.2em]">
            0{active + 1} / 0{heroSlides.length}
          </span>
          <div className="flex items-center gap-1.5">
            {heroSlides.map((item, index) => (
              <button
                key={item.id}
                type="button"
                aria-label={`切换至第 ${index + 1} 张焦点内容`}
                onClick={() => setActive(index)}
                className={`h-1.5 rounded-full transition-all cursor-pointer ${
                  index === active ? 'w-7 bg-accent-500' : 'w-3 bg-background-100/40 hover:bg-background-100/70'
                }`}
              ></button>
            ))}
          </div>
          <div className="flex items-center gap-2">
            <button
              type="button"
              aria-label="上一张"
              onClick={() => setActive((prev) => (prev - 1 + heroSlides.length) % heroSlides.length)}
              className="w-9 h-9 rounded-full border border-background-50/25 text-background-50 flex items-center justify-center hover:bg-background-50/15 transition-colors cursor-pointer"
            >
              <i className="ri-arrow-left-s-line text-lg"></i>
            </button>
            <button
              type="button"
              aria-label="下一张"
              onClick={() => setActive((prev) => (prev + 1) % heroSlides.length)}
              className="w-9 h-9 rounded-full border border-background-50/25 text-background-50 flex items-center justify-center hover:bg-background-50/15 transition-colors cursor-pointer"
            >
              <i className="ri-arrow-right-s-line text-lg"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}